export default __webpack_public_path__ + "static/media/d1.e741ead1.png";